module.exports = __webpack_public_path__ + "media/pl_pl_s5_Natasza.085d49fe.mp3";